export default "__VITE_ASSET__B98kepLD__"